import React from 'react';
import { List, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';

import { Utils } from 'app/main/components';
import jwtService from 'app/auth/services/jwtService';

interface AppSelectionTabProps {
	form: any;
	availableApps: any[];
	redirectApp: string | null;
	redirectTo: string | null;
}

export default function AppSelectionTab(props: AppSelectionTabProps) {
	function openApp(appUid, appUrl) {
		const redirectToAnotherApp = appUrl !== import.meta.env.VITE_ENDPOINT;

		jwtService
			.signInWithEmailAndPassword(props.form.email, props.form.password, appUid, redirectToAnotherApp)
			.then(data => {
				if (redirectToAnotherApp) {
					const baseUrl = `${appUrl}/login?token=${data.refreshToken}`;
					Utils.openLink({
						pathname: appUid === props.redirectApp ? `${baseUrl}&redirectTo=${props.redirectTo}` : baseUrl,
						external: true,
						newTab: import.meta.env.DEV
					});
				}
			})
			.catch(error => console.error(error));
	}

	return (
		<div className="mt-32 w-full text-center">
			<Typography className="mb-16 flex items-baseline font-medium" variant="body1">
				Seleziona l'applicazione a cui accedere:
			</Typography>
			<List className="max-h-256 w-full overflow-scroll py-0" dense>
				{props.availableApps.map((app, index) => (
					<ListItemButton
						key={app.usap_apps_uid}
						divider={index !== props.availableApps.length - 1}
						onClick={() => openApp(app.usap_apps_uid, app.apps_url)}
					>
						{/* <ListItemAvatar>
							<Icon icon="server" />
						</ListItemAvatar> */}
						<ListItemText primary={app.apps_name} secondary={app.apps_description} />
					</ListItemButton>
				))}
			</List>
		</div>
	);
}
